import { EMPTY_STATE, LOGIN, LOGOUT } from "../../actions/types";

const authentication = (state = {}, action: any) => {
  switch (action.type) {
    case LOGIN:
      return {
        user: action.data,
      };
    case LOGOUT:
      return {
        user: undefined,
      };
    case EMPTY_STATE:
      return {};
    default:
      return state;
  }
};

export default authentication;
